import { render } from "./BackgroundHalfCircle.vue?vue&type=template&id=26090e95"
const script = {}

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__